import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const TankCon = {
  id: "40",
  name: "Tanque",
  mainClass: "Estático",
  subtype: "Techo Cónico",
  variables: [
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "tankLevel",
      groups: "general",
      values: [50, 70, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.pH,
      unit: unitDefault.pH.metric,
      code: "tankPH",
      groups: "general",
      values: [5, 6, 8, 10],
      min: 0,
      max: 14
    },
    {
      type: unitTypes.conductivity,
      unit: unitDefault.conductivity.metric,
      code: "tankConductivity",
      groups: "general",
      values: [5, 6, 8, 10],
      min: 0,
      max: 14
    },
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "tankConcentration",
      groups: "general",
      values: [50, 70, 80, 90],
      min: 0,
      max: 100
    }
  ],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.capacity,
      unit: unitDefault.capacity.metric,
      code: "tankCapacity"
    },
    {
      value: 0,
      type: unitTypes.volume,
      unit: unitDefault.volume.metric,
      code: "tankVolume"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "tankDesignTemperature"
    }
  ]
};
